import { AxiosPromise } from 'axios';
import { ICreateGroupMemberLinkCommand } from './types';
import { instance } from '../../../../../../services/api';

export default (data: ICreateGroupMemberLinkCommand): AxiosPromise =>
  instance.post('api/localGroupMemberDetails/groupMemberLinks', data);
